export default {
    "Create role": "Create role",
    "Update role": "Update role",
    "Delete role": "Delete role",
    "List role": "List role",
    "Create user": "Create user",
    "Update user": "Update user",
    "Delete user": "Delete user",
    "List user": "List user",
    "Update brand": "Update brand",
    "List brand": "List brand",
    "Home page": "Home page",
    "New page": "New page",
    "Blanco": "Blanco",
    "Bosch": "Bosch",
    "Wmf": "Wmf",
    "Finish": "Finish",
    "Advise page": "Advise page",
    "Menu left": "Menu left",
    "Accessory page": "Accessory page",
    "Whybuy page": "Whybuy page",
    "Showroom page": "Showroom page",
    "Footer": "Footer",
    "Trade in sale page": "Trade in sale page",
    "Create category product": "Create category product",
    "Update category product": "Update category product",
    "Delete category product": "Delete category product",
    "List category product": "List category product",
    "Create product": "Create product",
    "Update product": "Update product",
    "Delete product": "Delete product",
    "List product": "List product",
    "Create tag": "Create tag",
    "Update tag": "Update tag",
    "Delete tag": "Delete tag",
    "List tag": "List tag",
    "Create attribute": "Create attribute",
    "Update attribute": "Update attribute",
    "Delete attribute": "Delete attribute",
    "List attribute": "List attribute",
    "Update order": "Update order",
    "View order": "View order",
    "List order": "List order",
    "Create category post": "Create category post",
    "Update category post": "Update category post",
    "Delete category post": "Delete category post",
    "List category post": "List category post",
    "Create post": "Create post",
    "Update post": "Update post",
    "Delete post": "Delete post",
    "List post": "List post",
    "Create show_room": "Create show_room",
    "Update show_room": "Update show_room",
    "Delete show_room": "Delete show_room",
    "List show_room": "List show_room",
    "Import excel show_room": "Import excel show_room",
    "Export excel show_room": "Export excel show_room",
    "Create warranties_center": "Create warranties_center",
    "Update warranties_center": "Update warranties_center",
    "Delete warranties_center": "Delete warranties_center",
    "List warranties_center": "List warranties_center",
    "Import excel warranties_center": "Import excel warranties_center",
    "Create support": "Create support",
    "Update support": "Update support",
    "Delete support": "Delete support",
    "List support": "List support",
    "View support": "View support",
    "Create rule": "Create rule",
    "Update rule": "Update rule",
    "Delete rule": "Delete rule",
    "List rule": "List rule",
    "Create promotion": "Create promotion",
    "Update promotion": "Update promotion",
    "Delete promotion": "Delete promotion",
    "List promotion": "List promotion",
    "Create warranty": "Create warranty",
    "Update warranty": "Update warranty",
    "Delete warranty": "Delete warranty",
    "List warranty": "List warranty",
    "Import excel warranty": "Import excel warranty",
    "Update error": "Update error",
    "Delete error": "Delete error",
    "List error": "List error",
    "Create comment": "Create comment",
    "Update comment": "Update comment",
    "Delete comment": "Delete comment",
    "List comment": "List comment",
    "Create advise": "Create advise",
    "Update advise": "Update advise",
    "Delete advise": "Delete advise",
    "List advise": "List advise",
    "List wards": "List wards",
    "Update trade_in_sale": "Update trade_in_sale",
    "Delete trade_in_sale": "Delete trade_in_sale",
    "List trade_in_sale": "List trade_in_sale"
}